<template>
    <div>
      <b-card>
        <b-card-header>
          <h2 :id="value.Name.replace(/\s+/g, '_')" class="heading">{{value.Name}}</h2>
          <i>{{value.School}}</i>
        </b-card-header>
        <center>
          <b-img :src='"../assets/img/seniors/" + value.ImageName + ".jpg"' fluid></b-img>
        </center>
        <b-card-text>
          
        </b-card-text>
      </b-card>
    </div>
</template>


<script>
export default {
    props: {
        value: {
            required: true,
            type: Object
        }
    },
}
</script>
